import React from 'react';
import BuildSettings from '../../buildSettings';
import { getMissingTranslationString, getSameTranslationString } from 'APP_ROOT/localization';

export default class LocalizationIssues extends React.PureComponent {
    
        render() {
            const authorizedEnv = ['dev', 'qa', 'test'];
            if (!authorizedEnv.includes(BuildSettings.environment())) {
                console.log('LocalizationIssues', BuildSettings.environment());
                return <h1 className='flex-grow-1 text-center'>Not Authorized</h1>;
            }

            const missedlist = getMissingTranslationString();
            const sameList = getSameTranslationString();
            return (
                <>
                    <div className='w-50 pl-4'>
                        <h1>Missed Translation</h1>
                        <ul>
                            {missedlist.map((item, index) => (
                                <li className='mb-2' key={index}><b>{`${index + 1}- ${item.key}`}</b> {`From ${item.from} To ${item.to}`}</li>
                            ))}
                        </ul>
                    </div>
                    <div className='w-50 pr-4'>
                        <h1>Similar Translation</h1>
                        <ul>
                            {sameList.map((item, index) => (
                                <li className='mb-2' key={index}><b>{`${index + 1}- ${item.key}`}</b> {` ${item.from} And ${item.to}`}</li>
                            ))}
                        </ul>
                    </div>
                </>
            );
        }
}